import announcement_lang from './announcement';
import login_lang from './login';

export default {
    ...login_lang, ...announcement_lang,
};
